module.exports = __webpack_public_path__ + "img/image162.ff92306b.png";